/**
 * Footer: mobile accordion toggle for footer columns
 */

export function initFooter() {
    const footerColumns = [...document.querySelectorAll('.footer-column')];
    if (!footerColumns.length) return;

    const mobileQuery = window.matchMedia('(max-width: 700px)');

    const syncFooterState = () => {
        const isMobile = mobileQuery.matches;

        footerColumns.forEach(column => {
            const toggle = column.querySelector('.footer-column-toggle');
            const list = column.querySelector('ul');
            if (!toggle || !list) return;

            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            list.hidden = isMobile ? !isExpanded : false;
            column.classList.toggle('is-open', isExpanded);
        });
    };

    footerColumns.forEach(column => {
        const toggle = column.querySelector('.footer-column-toggle');
        if (!toggle) return;

        toggle.addEventListener('click', () => {
            if (!mobileQuery.matches) return;

            const nextExpanded = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(nextExpanded));

            const indicator = toggle.querySelector('.footer-column-indicator');
            if (indicator) {
                indicator.textContent = nextExpanded ? '-' : '+';
            }

            syncFooterState();
        });
    });

    syncFooterState();
    mobileQuery.addEventListener('change', syncFooterState);
}
